module.exports = __webpack_public_path__ + "static/fig4-43a6dd48b2696c9ada11e1b4f52bd8c2.svg";